type QueryResult = {
  data: any;
  error: null;
  count?: number;
};

const emptyList = (): QueryResult => ({ data: [], error: null, count: 0 });
const emptyRow = (): QueryResult => ({ data: null, error: null, count: 0 });
const ok = (data: any = null): QueryResult => ({ data, error: null, count: 0 });

function createQuery(initial: QueryResult = emptyList()) {
  let result = initial;

  const chain: any = {
    select: (_columns?: string, options?: { count?: string; head?: boolean }) => {
      result = options?.head ? ok(null) : emptyList();
      return chain;
    },
    insert: (payload?: any) => {
      result = ok(Array.isArray(payload) ? payload : payload ? [payload] : []);
      return chain;
    },
    update: (payload?: any) => {
      result = ok(payload || null);
      return chain;
    },
    upsert: (payload?: any) => {
      result = ok(Array.isArray(payload) ? payload : payload ? [payload] : []);
      return chain;
    },
    delete: () => {
      result = ok(null);
      return chain;
    },
    eq: () => chain,
    neq: () => chain,
    gt: () => chain,
    gte: () => chain,
    lt: () => chain,
    lte: () => chain,
    like: () => chain,
    ilike: () => chain,
    in: () => chain,
    not: () => chain,
    or: () => chain,
    order: () => chain,
    limit: () => chain,
    range: () => chain,
    is: () => chain,
    single: () => {
      result = emptyRow();
      return chain;
    },
    maybeSingle: () => {
      result = emptyRow();
      return chain;
    },
    then: (resolve: any, reject: any) => Promise.resolve(result).then(resolve, reject),
    catch: (reject: any) => Promise.resolve(result).catch(reject),
    finally: (callback: any) => Promise.resolve(result).finally(callback),
  };

  return chain;
}

export const supabase: any = {
  from: () => createQuery(),
  rpc: () => createQuery(emptyList()),
  auth: {
    getUser: async () => ({
      data: {
        user: {
          id: "1",
          email: "suporte@cloudservidores.com",
        },
      },
      error: null,
    }),
    getSession: async () => ({
      data: {
        session: {
          user: {
            id: "1",
            email: "suporte@cloudservidores.com",
          },
        },
      },
      error: null,
    }),
    signInWithPassword: async () => ({ data: null, error: null }),
    signUp: async () => ({ data: null, error: { message: "Cadastro publico desativado" } }),
    signOut: async () => ({ error: null }),
    updateUser: async () => ({ data: null, error: null }),
    onAuthStateChange: () => ({
      data: {
        subscription: {
          unsubscribe: () => undefined,
        },
      },
    }),
  },
  storage: {
    from: () => ({
      upload: async () => ({ data: null, error: null }),
      remove: async () => ({ data: null, error: null }),
      download: async () => ({ data: null, error: null }),
      getPublicUrl: () => ({ data: { publicUrl: "" } }),
    }),
  },
};
